import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContainer = styled.div<{ $maxWidth?: string }>`
  background-color: ${Tokens.ColorWhite};
  border-radius: ${Tokens.RadiusInput};
  padding: 24px;
  min-width: 400px;
  max-width: ${(props) => props.$maxWidth || '500px'};
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

export const ModalHeader = styled.div`
  margin-bottom: 20px;
`

export const ModalTitle = styled.h3`
  margin: 0;
  text-align: center;
  flex: 1;
  color: ${Tokens.ColorTextPrimary};
`

export const CloseButtonContainer = styled.div`
  position: absolute;
  right: 0;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
